const VocabInvitation = {
  greeting: [
    "Hola",
    "Hello"
  ],
  has_invited_you: [
    "Te ha invitado a nuestra red, desde aquí puedes:",
    "has invited you to our network, from here you can:"
  ],
  action_login_link: [
    "Inicia sesión",
    "Log in"
  ],
  action_login_suffix: [
    " para permitirle acceso a tu perfil.",
    " to allow access to your profile."
  ],
  action_calendar_link: [
    "Haz click aquí",
    "Click here"
  ],
  action_calendar_suffix: [
    " para acceder a su calendario y agenda una cita.",
    " to access its agenda and schedule an appointment."
  ],
  action_register_prefix: [
    "O si eres nuevo ",
    "Or if you are new, "
  ],
  action_register_link: [
    "registrarte",
    "register"
  ],
  action_register_suffix: [
    " y forma parte de nuestra comunidad.",
    " and become part of our community."
  ]
};

export default VocabInvitation;